import React from 'react';

export function GripVerticalIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M8 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M8 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M8 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M14 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M14 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M14 19a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    </svg>
  );
}

export function GripHorizontalIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 9a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M4 15a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M11 9a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M11 15a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M18 9a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M18 15a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    </svg>
  );
}
